import React, { createContext, useState, useCallback } from 'react';
import Alerta from '../components/Alerta';

export const AlertaContext = createContext({
  handleOpenAlerta: () => {},
  handleCloseAlerta: () => {},
  stateAlerta: { open: false, tipo: 'info', mensaje: '' },
});

export const AlertaProvider = ({ children }) => {
  const [stateAlerta, setStateAlerta] = useState({
    open: false,
    tipo: 'info',
    mensaje: '',
  });

  const handleOpenAlerta = useCallback((tipo = 'info', mensaje = '') => {
    setStateAlerta({
      open: true,
      tipo,
      mensaje,
    });
  }, []);

  const handleCloseAlerta = useCallback(() => {
    setStateAlerta((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return (
    <AlertaContext.Provider value={{ handleOpenAlerta, handleCloseAlerta, stateAlerta }}>
      {children}
      <Alerta />
    </AlertaContext.Provider>
  );
};

export default AlertaContext;
